module.exports = __webpack_public_path__ + "assets/img/3.5ce69e8d.png";